import { Alert, Text } from '@chakra-ui/react';
import { useTranslation } from 'localization';

const Completed: React.FC = () => {
  const { t } = useTranslation('component.requests');

  return (
    <Alert.Root status="info">
      <Text color="info">{t('userMustPayCashToU')}</Text>
    </Alert.Root>
  );
};
export default Completed;
